import React, { useEffect, useState } from 'react';


const hiddenSettings = {
  is_shopping_list_enabled: false,
  is_recipe_library_enabled: false,
};

const rows = [
  {
    key: 'is_shopping_list_enabled',
    label: 'Einkaufsliste anzeigen',
    description: 'Blendet die gemeinsame Einkaufsliste im Mitarbeiter-Dashboard ein.',
    testId: 'shopping-list-enabled-toggle',
  },
  {
    key: 'is_recipe_library_enabled',
    label: 'Rezepte anzeigen',
    description: 'Blendet die Rezeptsammlung im Mitarbeiter-Dashboard ein.',
    testId: 'recipes-enabled-toggle',
  },
];

const normalizeSettings = (settings = {}) => ({
  is_shopping_list_enabled: settings.is_shopping_list_enabled === true,
  is_recipe_library_enabled: settings.is_recipe_library_enabled === true,
});

const OrganizationFeatureSettings = ({
  settings = hiddenSettings,
  onSave,
  disabled = false,
}) => {
  const [current, setCurrent] = useState(() => normalizeSettings(settings));
  const [savingKey, setSavingKey] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    setCurrent(normalizeSettings(settings));
  }, [settings]);

  const toggle = async (key) => {
    if (disabled || savingKey) return;
    const previous = current;
    const next = { ...current, [key]: !current[key] };
    setCurrent(next);
    setSavingKey(key);
    setError('');
    try {
      await onSave(next);
    } catch (requestError) {
      setCurrent(previous);
      setError(requestError.response?.data?.detail || requestError.message || 'Die Einstellung konnte nicht gespeichert werden.');
    } finally {
      setSavingKey(null);
    }
  };

  return (
    <section aria-labelledby="organization-feature-settings-heading">
      <h4 id="organization-feature-settings-heading" className="text-lg font-semibold text-gray-900">
        Funktionen im Mitarbeiter-Dashboard
      </h4>
      <p className="mt-1 text-sm text-gray-500">
        Legt fest, welche zusätzlichen Werkzeuge Mitarbeiter sehen.
      </p>
      {error && <p role="alert" className="mt-3 text-sm text-red-700">{error}</p>}
      <div className="mt-4 divide-y divide-gray-200 border-y border-gray-200">
        {rows.map(row => {
          const enabled = current[row.key];
          return (
            <div key={row.key} className="flex items-center justify-between gap-5 py-4">
              <div>
                <p className="font-medium text-gray-900">{row.label}</p>
                <p className="mt-1 text-sm text-gray-500">{row.description}</p>
              </div>
              <button
                type="button"
                role="switch"
                aria-checked={enabled}
                aria-label={row.label}
                data-testid={row.testId}
                disabled={disabled || Boolean(savingKey)}
                onClick={() => toggle(row.key)}
                className={`relative inline-flex h-7 w-12 flex-shrink-0 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 disabled:cursor-wait disabled:opacity-60 ${
                  enabled ? 'bg-green-600' : 'bg-gray-300'
                }`}
              >
                <span
                  className={`inline-block h-5 w-5 rounded-full bg-white shadow-sm transition-transform ${
                    enabled ? 'translate-x-6' : 'translate-x-1'
                  }`}
                />
              </button>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default OrganizationFeatureSettings;
